<script lang="ts" setup generic="TVal">
import { TooltipHelp } from '..';
import type { IInputRadioPropsWithoutModelValue } from './PropInterfaces';

const props = withDefaults(defineProps<IInputRadioPropsWithoutModelValue<TVal>>(), {});

const modelValue = defineModel<TVal>({ required: true });
</script>
<template>
    <div class="form-check">
        <label
            :class="'text-nowrap form-check-label' + ' ' + (labelclass ?? '')"
            v-if="translationkey"
        >
            <span>
                {{ $tm(translationkey) }}
                <TooltipHelp
                    v-if="props.tooltip"
                    :text="props.tooltip"
                    class="ms-auto"
                />
            </span>
            <input
                v-model="modelValue"
                :value="value"
                :name="name"
                type="radio"
                class="form-check-input"
                v-bind:checked="modelValue === value"
            />
        </label>
    </div>
</template>
